 function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }
import addNodeToArray from '~/utils/relay/addNodeToArray'
import safeRemoveNodeFromArray from '~/utils/relay/safeRemoveNodeFromArray'

const handleUpdateSpotlightResults = (
  reflection,
  reflectionGroup,
  oldReflectionGroupId,
  store
) => {
  const meetingId = reflection.getValue('meetingId') 
  const meeting = store.get(meetingId)
  // reflectionGroup is null if there's no target type
  if (!meeting || !reflectionGroup) return
  const spotlightSearchQuery = (meeting.getValue('spotlightSearchQuery') || '') 
  const spotlightGroup = _optionalChain([meeting, 'optionalAccess', _ => _.getLinkedRecord, 'call', _2 => _2('spotlightGroup')])
  const spotlightGroupId = _optionalChain([spotlightGroup, 'optionalAccess', _3 => _3.getValue, 'call', _4 => _4('id')])
  const viewer = store.getRoot().getLinkedRecord('viewer')
  if (!viewer || !spotlightGroupId) return
  const similarReflectionGroups = viewer.getLinkedRecords('similarReflectionGroups', {
    reflectionGroupId: spotlightGroupId,
    searchQuery: spotlightSearchQuery
  })
  if (!similarReflectionGroups) return
  const reflectionsCount = _optionalChain([reflectionGroup, 'optionalAccess', _5 => _5.getLinkedRecords, 'call', _6 => _6('reflections'), 'optionalAccess', _7 => _7.length])
  const oldReflectionGroup = store.get(oldReflectionGroupId)
  const oldReflections = _optionalChain([oldReflectionGroup, 'optionalAccess', _8 => _8.getLinkedRecords, 'call', _9 => _9('reflections')])
  const reflectionId = reflection.getValue('id')
  const isOldGroupEmpty =
    _optionalChain([oldReflections, 'optionalAccess', _10 => _10.length]) === 1 && oldReflections[0].getValue('id') === reflectionId
  const reflectionGroupId = reflectionGroup.getValue('id')
  const groupsIds = similarReflectionGroups
    .map((group) => group.getValue('id'))
    .concat(spotlightGroupId)
  const isInSpotlight = groupsIds.includes(reflectionGroupId)
  const wasInSpotlight = groupsIds.includes(oldReflectionGroupId)
  // added to another group. Remove old reflection group
  if (isOldGroupEmpty && wasInSpotlight) {
    safeRemoveNodeFromArray(oldReflectionGroupId, viewer, 'similarReflectionGroups', {
      storageKeyArgs: {
        reflectionGroupId: spotlightGroupId,
        searchQuery: spotlightSearchQuery
      }
    })
  }
  // ungrouping created a new group or was added to a group in the kanban
  // reflectionsCount is undefined when ungrouping
  // don't use else if: when a result is added to a kanban group, remove old empty group and add new one
  if (!isInSpotlight && reflectionsCount !== undefined && wasInSpotlight) {
    addNodeToArray(reflectionGroup, viewer, 'similarReflectionGroups', 'sortOrder', {
      storageKeyArgs: {
        reflectionGroupId: spotlightGroupId,
        searchQuery: spotlightSearchQuery
      }
    })
  }
}

export default handleUpdateSpotlightResults
